import React, { Component } from "react";
import {withAlert} from "react-alert";
import {config} from "../../config";
import axios from "axios";
import Loading from "../Loading";
import Modal from "react-modal";

class SubAccounts extends Component{
    constructor() {
        super();
        this.state = {
            isAddSubAccountOpen:false,
            isDeleteSubAccountOpen:false,
            data:[],
            loading:true,
            editingSubAccount:"",
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.getProfileData = this.getProfileData.bind(this);
        this.closeAddSubAccount = this.closeAddSubAccount.bind(this);
        this.goToAddSubAccount=this.goToAddSubAccount.bind(this);
        this.saveNewSubAccount = this.saveNewSubAccount.bind(this);
        this.deleteSubAccount = this.deleteSubAccount.bind(this);
    }
    handleSelect(id) {
        let array = this.state.selectedDataId;
        if (array.includes(id)) {
            let index = array.indexOf(id);
            if (index > -1) {
                array.splice(index, 1);
            }
        } else {
            array.push(id);
        }
        this.setState({ selectedDataId: array });
    }
    getProfileData(){
        this.setState({loading:true});
        let req = {
            method: "get",
            url: config.baseUrl + "api/v2/profile",
            headers: {
                Authorization: "Bearer " + config.token
            },
        };
        axios(req)
            .then((resp) => {
                if (resp.data.status === 1) {
                    this.setState({
                        data: resp.data.data.sub_accounts,
                        loading: false,
                    });
                }
            })
            .catch((err) => {
                this.setState({loading:false});
                this.props.alert.error(err.response.data.errors ? err.response.data.errors[0].message : err.response.data.message );
            });
    }
    closeAddSubAccount(){
        this.setState({
            isAddSubAccountOpen:false,
            loading:false
        })
    }
    goToAddSubAccount(){
        this.setState({
            isAddSubAccountOpen:true,
            isDeleteSubAccountOpen:false,
            loading:false
        })
    }
    deleteSubAccount(){
        this.setState({ loading: true });
        let req = {
            method: "delete",
            url:
                config.baseUrl + "api/v2/profile/sub-accounts/" + this.state.editingSubAccount,
            headers: {
                Authorization: "Bearer " + config.token,
            },
        };
        axios(req)
            .then((resp) => {
                if (resp.data.status === 1) {
                    this.setState({
                        loading:false,
                        editingSubAccount:"",
                        data:resp.data.data.map((account)=>{
                            return account.replace('98','0')
                        }),
                        isDeleteSubAccountOpen:false
                    })
                    this.props.alert.success("اکانت مورد نظر با موفقیت حذف شد.");
                }
            })
            .catch((err) => {
                this.setState({loading:false,isDeleteSubAccountOpen:false,editingSubAccount:""})
                this.props.alert.error(err.response.data.errors ? err.response.data.errors[0].message : err.response.data.message );
            });
    }
    saveNewSubAccount(){
        this.setState({ loading: true });
        let mobile = document
            .getElementById("addSubAccount")
            .value.replace(/۰/g, "0")
            .replace(/۱/g, "1")
            .replace(/۲/g, "2")
            .replace(/۳/g, "3")
            .replace(/۴/g, "4")
            .replace(/۵/g, "5")
            .replace(/۶/g, "6")
            .replace(/۷/g, "7")
            .replace(/۸/g, "8")
            .replace(/۹/g, "9");
        const mobileRegex = /^(989|09)\d{9}$/;
        if (mobile !== "") {
            if (!mobileRegex.test(mobile)) {
                this.setState({ loading: false });
                this.props.alert.error("فرمت شماره موبایل صحیح نمی باشد.");
                return;
            }
            let req = {
                method: "post",
                url: config.baseUrl + "api/v2/profile/sub-accounts" ,
                headers: {
                    Authorization: "Bearer " + config.token,
                },
                data:{
                    mobile:mobile
                }
            };

            axios(req)
                .then((resp) => {
                    if (resp.data.status === 1) {
                        this.setState({
                            loading:false,
                            isAddSubAccountOpen:false,
                            data:resp.data.data.map((account)=>{
                                return account.replace('98','0')
                            }),
                        })
                        this.props.alert.success("اکانت مورد نظر با موفقیت اضافه شد.");
                    }
                })
                .catch((err) => {
                    this.setState({loading:false,isAddSubAccountOpen:false})
                    this.props.alert.error(err.response.data.errors ? err.response.data.errors[0].message : err.response.data.message );
                });
        } else {
            this.setState({ loading: false });
            this.props.alert.error("این فیلد اجباری است.");
        }
    }
    componentDidMount() {
        this.getProfileData();
    }
    render() {
        return(
            <div className="content col-lg-12 col-md-12">
                <Loading loading={this.state.loading} />
                <div className="content-head">
                    <button
                        className="blueBtn"
                        onClick={() => {
                            this.setState({isAddSubAccountOpen: true});
                        }}
                    >
                        افزودن اکانت زیر مجموعه
                    </button>
                </div>
                <div id={"tbl"} className="content-body">
                    <table className="transaction tbl">
                        <thead>
                        <tr>
                            <th>شماره</th>
                            <th>موبایل</th>
                            <th>گزینه ها</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((account,index)=>(
                                <tr>
                                    <td>
                                        {index+1}
                                    </td>
                                    <td>
                                        <p>{account}</p>
                                    </td>
                                    <td>
                                        <button className="delete-btn" title="حذف" onClick={()=>{
                                            this.setState({
                                                isDeleteSubAccountOpen:true,
                                                editingSubAccount:account
                                            })
                                        }}>
                                            <i className="icon-delete" title="حذف"/>
                                        </button>
                                    </td>
                                </tr>
                                )
                            )}
                        </tbody>
                    </table>
                    {this.state.data.map((account,index)=>(
                        <div className="mobile-info-card row">
                            <div className="col-xs-12 text-center">
                                <p>{account}</p>
                            </div>
                            <div className="col-xs-12 card-btn-div" style={{padding: '0 10px'}}>
                                <div className="col-xs-12">
                                       <button className='delete-btn' style={{width: '100%'}} onClick={()=>{                                          this.setState({
                                           isDeleteSubAccountOpen:true,
                                           editingSubAccount:account
                                       })}}>حذف</button>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
                <Modal
                    isOpen={this.state.isDeleteSubAccountOpen}
                    onRequestClose={() => {
                        this.setState({ isDeleteSubAccountOpen: false});
                    }}
                    style={{
                        content: { top: "calc(100vh / 8)", left: "35%", right: "35%" },
                    }}
                >
                    <div className="title">
                        <p>حذف اکانت</p>
                    </div>
                    <p
                        style={{
                            fontSize: "14px",
                            textAlign: "center",
                            marginBottom: "40px",
                        }}
                    >
                        آیا از حذف این اکانت اطمینان دارید؟
                    </p>
                    <button
                        onClick={this.deleteSubAccount}
                        className="blueBtn btn"
                        style={{ padding: "15px 85px" }}
                    >
                        بله
                    </button>
                    <button
                        className="pinkBtn btn"
                        style={{ marginRight: "15px", padding: "15px 75px" }}
                        onClick={() => {
                            this.setState({ isDeleteSubAccountOpen: false });
                        }}
                    >
                        انصراف
                    </button>
                </Modal>
                <Modal
                    isOpen={this.state.isAddSubAccountOpen}
                    onRequestClose={this.closeAddSubAccount}
                    style={{
                        content: { top: "calc(100vh / 5)", left: "40%", right: "40%" },
                    }}
                >
                    <div className="title">
                        <p>شماره موبایل اکانت زیر مجموعه</p>
                    </div>
                    <p
                        style={{
                            fontSize: "12px",
                            textAlign: "center",
                            marginBottom: "40px",
                            color: "#B5B5B5",
                        }}
                    >
                        در قسمت پایین موبایل مورد نظر را وارد کنید.
                    </p>
                    <div className="input-div ">
                        <h5>موبایل</h5>
                        <div className="input-group">
                            <input id="addSubAccount" className="input num" placeholder="09..." />
                        </div>
                    </div>
                    <button
                        onClick={this.saveNewSubAccount}
                        className="blueBtn btn"
                        style={{ padding: "15px 50px" }}
                    >
                        ثبت
                    </button>
                    <button
                        className="pinkBtn btn"
                        style={{ marginRight: "15px", padding: "15px 25px" }}
                        onClick={this.closeAddSubAccount}
                    >
                        انصراف
                    </button>
                </Modal>
            </div>
        );
    }
}

export default withAlert(SubAccounts);